<template>
  <div class="active-wtxh">
    <div class="active-wtxh-content">
      <ul class="news-grid" v-if="list.length">
        <li
          class="news-card"
          v-for="(item, idx) in list"
          :key="item.id"
          :style="{'animation-delay': idx * 50 + 'ms'}"
          @animationend="onCardAnimated"
          @click="toActiveInfo(item)"
        >
          <div class="card-cover">
            <img :src="item.image" />
          </div>
          <div class="card-info">
            <p class="card-title">{{ item.name }}</p>
            <p class="card-date">
              <img src="@/assets/clock-grey-ico.png" class="date-icon" />
              <span>{{ item.created_at }}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="empty-tip" v-else-if="loaded">暂无相关内容</div>
      <pagination-wtxh
        v-if="num > 0"
        :num="num"
        :limit="limit"
        @getNew="getNew"
      ></pagination-wtxh>
    </div>
  </div>
</template>

<script>
import PaginationWtxh from "@/components/pc/paginationWtxh.vue";

export default {
  name: "ActiveListWtxh",
  components: {
    PaginationWtxh,
  },
  data() {
    return {
      moduleId: "",
      list: [],
      num: 0,
      limit: 8,
      nowPage: 1,
      loaded: false,
    };
  },
  watch: {
    "$route.params.id"(newId) {
      this.moduleId = newId;
      this.nowPage = 1;
      this.getList();
    },
  },
  mounted() {
    this.moduleId = this.$route.params.id;
    this.getList();
  },
  methods: {
    getList() {
      this.$axios
        .post(`/v1/article/list`, {
          page: this.nowPage,
          pre_page: this.limit,
          module_id: this.moduleId,
        })
        .then((res) => {
          this.list = res.data.data;
          this.num = res.data.total;
          this.loaded = true;
        });
    },
    toActiveInfo(data) {
      if (data.type === 0) {
        this.$router.push("/activeInfo/" + data.data_id);
      } else if (data.type === 1) {
        window.open(data.pc_link);
      }
    },
    getNew(nowPage) {
      this.nowPage = nowPage;
      this.getList();
    },
    onCardAnimated(e) {
      e.target.style.animation = "none";
      e.target.style.opacity = "1";
    },
  },
};
</script>

<style scoped lang="scss">
.active-wtxh {
  background-color: rgba(247, 251, 252, 1);
}
.active-wtxh-content {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 71px;
}
.news-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 26px;
  align-content: flex-start;
}
.news-card {
  width: 280px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 17px 0px rgba(200, 200, 200, 0.4);
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  animation: cardFadeIn 0.4s ease forwards;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  }
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.card-cover {
  width: 280px;
  height: 162px;
  overflow: hidden;
  border-radius: 6px 6px 0 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.card-info {
  padding: 16px 20px 20px;
}
.card-title {
  font-size: 18px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}
.card-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.date-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.empty-tip {
  text-align: center;
  padding: 80px 0;
  font-size: 16px;
  color: #999;
}
</style>
